import { ILookupState } from 'legacy/lut/store/state'

import { IState } from 'core/store'

export const getOwnerId = (state: IState) => state.app.app.ownerId
export const getApp = (state: IState) => state.app.app
export const getUser = (state: IState) => state.app.user
export const selectJbpPartnerAccess = (state: ILookupState) => state.lookupOld.jbpPartnerAccess

export const selectLandingAccessState = (state: ILookupState) => state.lookupOld.landingAccessState

export const selectCountries = (state: ILookupState) => state.lookupOld.references.countries
export const selectLocales = (state: ILookupState) => state.lookupOld.references.locales
export const selectOrganizations = (state: ILookupState) => state.lookupOld.references.organizations
export const selectAssociativeLanguages = (state: ILookupState) =>
  state.lookupOld.references.associativeLanguages
export const selectLanguages = (state: ILookupState) => state.lookupOld.references.languages
export const selectEnableRecord = (state: ILookupState) => state.lookupOld.enableRecorder
export const selectUserPoints = (state: ILookupState) => state.lookupOld.userPoints
export const selectUserLevel = (state: ILookupState) => state.lookupOld.userLevel
